module.exports = __webpack_public_path__ + "img/survey-member.0ab4a0bd.png";